(function () {
    'use strict';

    angular
        .module('Lavpop-store.directives')
        .directive('header', Header)

    /** @ngInject */
    function Header($rootScope, $window, $timeout, AuthenticationService, ProductService, HelperService, PATHS, DATA_EVENTS) {
        function HeaderController($scope) {
            const vm = this;

            vm.logout = () => AuthenticationService.logout(true);

            vm.cartNumber = () => ProductService.getProductsCount();

            vm.onChangeUnit = () => {
                const currentSelectedUnit = AuthenticationService.getSelectedUnit();

                if (vm.selectedUnit.Id && vm.selectedUnit.Id != currentSelectedUnit.Id) {
                    AuthenticationService
                        .setUnit(vm.selectedUnit.Id)
                        .then(response => {
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                            // AuthenticationService.configureUserPermissions($state.current);

                            console.log('response: ', response);
                            if (response.error)
                                HelperService.handleStateChangeError(response);
                        }, error => {
                            console.log('error: ', error);
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                            // AuthenticationService.configureUserPermissions($state.current);

                            HelperService.handleStateChangeError(error);
                        })
                }
            }

            vm.toggleSelectUnit = () => {
                $rootScope.showSelectUnit = !$rootScope.showSelectUnit;
            }

            let removeWatchWindow = angular.element($window).on('resize', () => {
                $rootScope.isMobile = HelperService.isScreenSmaller(991);

                $timeout(() => {
                    vm.isMobile = $rootScope.isMobile;
                });
            });

            var removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                init();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
            })

            init();

            function init() {
                const authSelectedUnit = AuthenticationService.getSelectedUnit();

                vm.loggedUserData = AuthenticationService.getUserData();
                vm.units = AuthenticationService.getUnits();

                let foundUnit = vm.units.find(unit => (unit.Id == authSelectedUnit.Id));

                if (foundUnit)
                    vm.selectedUnit = foundUnit;

                vm.isMobile = $rootScope.isMobile;
            }
        }

        return {
            bindToController: true,
            controller: HeaderController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/header/header.html`,
            scope: {
                addDivisor: '='
            }
        }
    }
}());